//
//
//
//
//
//
//
//
//
//
//
//
//

import frag from 'vue-frag';

export default {
  directives: { frag },
  props: {
    collection: {
      type: Object,
      required: true,
    },
  },
};
